/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                 from 'react';
import { StyledContentIcon } from '../../atoms/StyledContentIcon';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const ContentIcon = ({ icon }) => (
    <StyledContentIcon>
        {icon}
    </StyledContentIcon>
);



// WEBPACK FOOTER //
// ./src/components/molecules/ContentIcon/index.js